const ServicesRoutes = {
  getAllServices: "/service/serviceGetAll"
}

export default ServicesRoutes;